import React, { Component } from "react";
import Header from "../../Header";
import Footer from "../../Footer";
import Zoom from "react-reveal/Zoom";
import Roll from "react-reveal/Roll";
import Helmet from "../../Helmet";
import saint_omer from "../../../img/saint-omer/saint-omer.jpg";
import saint_omer2 from "../../../img/saint-omer/saint-omer2.jpg";
import saint_omer3 from "../../../img/saint-omer/saint-omer3.jpg";

class Saint_Omer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nom: "Saint-Omer",
      image: "saint-omer.jpg",
      piste: "cendrée",
      corde: "gauche",
      circonference: "1 000 m",
      region: "Hauts-de-France",
      departement: "Pas-de-Calais",
      ville: "Saint-Omer",
      surnom: "hippodrome des Bruyères"
    };
  }
  render() {
    return (
      <div>
        <Helmet
          title={"Saint-Omer Hippodromes visités"}
          link={"http://map.guillaumequeste.fr/saint-omer"}
        />
        <Header />
        <Footer />
        <div className="fiche">
          <div className="image">
            <img
              src={saint_omer}
              alt={this.state.nom}
              className="tailleImage"
            />
          </div>
          <Roll right>
            <div className="description">
              <h2 className="titreCard">{this.state.nom}</h2>
              <ul>
                <li className="liCard">
                  <strong>Piste : </strong>
                  {this.state.piste}
                </li>
                <li className="liCard">
                  <strong>Corde : </strong>
                  {this.state.corde}
                </li>
                <li className="liCard">
                  <strong>Circonference : </strong>
                  {this.state.circonference}
                </li>
                <li className="liCard">
                  <strong>Région : </strong>
                  {this.state.region}
                </li>
                <li className="liCard">
                  <strong>Département : </strong>
                  {this.state.departement}
                </li>
                <li className="liCard">
                  <strong>Ville à proximité : </strong>
                  {this.state.ville}
                </li>
                <li className="liCard">
                  <strong>Surnom : </strong>
                  {this.state.surnom}
                </li>
                <li className="liCard">
                  <i>&darr; + de photos &darr;</i>
                </li>
              </ul>
            </div>
          </Roll>
        </div>
        <div className="plusDePhotos der">
          <Zoom>
            <div className="image">
              <img
                src={saint_omer2}
                alt="saint-omer2"
                className="tailleImagePlus"
              />
            </div>
          </Zoom>
          <Zoom>
            <div className="image">
              <img
                src={saint_omer3}
                alt="saint-omer3"
                className="tailleImagePlus"
              />
            </div>
          </Zoom>
        </div>
      </div>
    );
  }
}

export default Saint_Omer;
